// src/components/titlebar/components/HelpMenu.tsx

import React from "react"
import { Menu, MenuItem } from "@mui/material"
import { Info as InfoIcon } from "@mui/icons-material"
import { HelpMenuButton, menuPaperStyle } from "../styles/titleBarStyles"
import type { HelpMenuProps } from "../types/titleBarTypes"

const HelpMenu: React.FC<HelpMenuProps> = ({
  anchorEl,
  onOpen,
  onClose,
  onShowVersion,
  onShowVersionFeatures,
  showServerUpdate = false,
  onShowServerUpdate,
}) => {
  return (
    <>
      <HelpMenuButton startIcon={<InfoIcon sx={{ fontSize: 14 }} />} onClick={onOpen}>
        정보
      </HelpMenuButton>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={onClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        PaperProps={{
          sx: {
            ...menuPaperStyle,
            minWidth: 260,
          },
        }}
      >
        <MenuItem onClick={onShowVersion}>클라이언트 정보</MenuItem>
        <MenuItem onClick={onShowVersionFeatures}>시그마차트 버전별 기능</MenuItem>
        {showServerUpdate && <MenuItem onClick={onShowServerUpdate}>서버 업데이트</MenuItem>}
      </Menu>
    </>
  )
}

export default HelpMenu

